import { createMuiTheme } from '@material-ui/core/styles';

// Create a theme instance.
const materialTheme = createMuiTheme({
    typography: {
        fontFamily: 'Atlas Grotesk Web, sans-serif',
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1300,
            xl: 1920,
        },
    },
});

export default materialTheme;
